import type { Training, WorkoutType, WorkoutTypeProfile } from '../types/base'

const WORKOUT_TYPE_DOMINANCE_THRESHOLD = 0.6

export const getWorkoutTypeProfile = (training: Training): WorkoutTypeProfile => {
	if (training.type_profile) {
		return training.type_profile
	}

	const exerciseTypeCounts: WorkoutTypeProfile['exercise_type_counts'] = {
		cardio: 0,
		strength: 0,
	}

	training.exercises.forEach(exercise => {
		const exerciseType = exercise.exercise_detail?.type
		if (exerciseType === 'cardio' || exerciseType === 'strength') {
			exerciseTypeCounts[exerciseType] += 1
		}
	})

	const totalExercises = exerciseTypeCounts.cardio + exerciseTypeCounts.strength
	let workoutType: WorkoutType | null = null

	if (totalExercises > 0) {
		const dominantType =
			exerciseTypeCounts.cardio > exerciseTypeCounts.strength ? 'cardio' : 'strength'
		const dominantCount = exerciseTypeCounts[dominantType]
		workoutType =
			dominantCount / totalExercises > WORKOUT_TYPE_DOMINANCE_THRESHOLD
				? dominantType
				: 'mixed'
	}

	return {
		workout_type: workoutType,
		exercise_type_counts: exerciseTypeCounts,
	}
}
